module.exports = __webpack_public_path__ + "img/tx.d4b04560.png";